import { TrackingClient } from '@sparefoot/tracking-client';

export const trackCTAClick = (click_id, click_name, click_text, click_url) => {
	let trackingProps = { click_id, click_name, click_text, click_url };
	if (typeof window !== 'undefined' && TrackingClient) {
		TrackingClient.trackCTAClick(trackingProps);
	}
};

export const trackContactLinkClick = (
	click_id,
	click_name,
	click_text,
	contact_type,
) => {
	let trackingProps = {
		click_id,
		click_name,
		click_text,
		contact_type,
	};
	if (typeof window !== 'undefined' && TrackingClient) {
		TrackingClient.trackContactLinkClicked(trackingProps);
	}
};

export const trackOutboundLinkClick = (
	click_id,
	click_name,
	click_text,
	click_url,
) => {
	let trackingProps = {
		click_id,
		click_name,
		click_text,
		click_url,
	};

	if (typeof window !== 'undefined' && TrackingClient) {
		TrackingClient.trackOutboundLinkClicked(trackingProps);
	}
};
